var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MessageDialog } from "../components/messageDialog";
import * as EmailDialog from "../components/addEmailDialog";
import * as DeleteConfirmDialog from "../components/deletePhoneConfirmDialog";
import * as PhoneDialog from "../components/addPhoneDialog";
import * as UpdatePhoneDialog from "../components/updatePhoneDialog";
import axios from "axios";
import { startTimer } from "../components/updatePhoneDialog";
var _components = {};
var timerDurationDefault = 120;
$(function () {
    _components.sendSmsButton = $('#sendSmsButton').on('click', sendSms_onClick);
    _components.sendEmailButton = $('#sendEmailButton').on('click', sendEmail_onClick);
    _components.updatePhoneButton = $('#updatePhoneButton').on('click', updatePhone);
    _components.deletePhoneButton = $('#deletePhoneButton').on('click', deletePhone_onClick);
    _components.resendCodeBtn = $('#resendCodeBtn').on('click', function () {
        return __awaiter(this, void 0, void 0, function () {
            var phoneNumber;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        phoneNumber = $('#updatePhoneDialogInput').val();
                        return [4 /*yield*/, UpdatePhoneDialog.sendCheckCode({ PhoneNumber: phoneNumber })];
                    case 1:
                        _a.sent();
                        startTimer(timerDurationDefault, true);
                        return [2 /*return*/];
                }
            });
        });
    });
    _components.messageDialog = new MessageDialog();
});
function sendSms_onClick(e) {
    return __awaiter(this, void 0, void 0, function () {
        var _phone;
        var _this = this;
        return __generator(this, function (_a) {
            e.preventDefault();
            PhoneDialog.show()
                .then(function (phone) { return __awaiter(_this, void 0, void 0, function () {
                var response, err_1;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _phone = phone;
                            _b.label = 1;
                        case 1:
                            if (!true) return [3 /*break*/, 7];
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 6]);
                            if (!_phone)
                                throw new Error('Введите номер телефона');
                            if (!isValidPhone(_phone))
                                throw new Error('Введите корректный номер телефона');
                            return [4 /*yield*/, sendSmsInfo({ PhoneNumber: _phone })];
                        case 3:
                            response = _b.sent();
                            PhoneDialog.close();
                            return [3 /*break*/, 7];
                        case 4:
                            err_1 = _b.sent();
                            PhoneDialog.setError(((_a = err_1.response) === null || _a === void 0 ? void 0 : _a.data) || err_1.message);
                            return [4 /*yield*/, PhoneDialog.show()
                                    .then(function (phone) {
                                    _phone = phone;
                                })];
                        case 5:
                            _b.sent();
                            return [3 /*break*/, 6];
                        case 6: return [3 /*break*/, 1];
                        case 7: return [2 /*return*/, response];
                    }
                });
            }); })
                .catch(function (e) {
                PhoneDialog.close();
            });
            return [2 /*return*/];
        });
    });
}
function sendSmsInfo(data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.post('/info/sms', data)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function sendEmail_onClick(e) {
    return __awaiter(this, void 0, void 0, function () {
        var _email;
        var _this = this;
        return __generator(this, function (_a) {
            e.preventDefault();
            EmailDialog.show()
                .then(function (email) { return __awaiter(_this, void 0, void 0, function () {
                var response, err_2;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _email = email;
                            _b.label = 1;
                        case 1:
                            if (!true) return [3 /*break*/, 7];
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 6]);
                            if (!_email)
                                throw new Error('Введите электронную почту');
                            if (!isValidEmail(_email))
                                throw new Error('Введите корректный адрес электронной почты');
                            return [4 /*yield*/, sendEmailInfo({ Email: _email })];
                        case 3:
                            response = _b.sent();
                            EmailDialog.close();
                            return [3 /*break*/, 7];
                        case 4:
                            err_2 = _b.sent();
                            EmailDialog.setError(((_a = err_2.response) === null || _a === void 0 ? void 0 : _a.data) || err_2.message);
                            return [4 /*yield*/, EmailDialog.show()
                                    .then(function (email) {
                                    _email = email;
                                })];
                        case 5:
                            _b.sent();
                            return [3 /*break*/, 6];
                        case 6: return [3 /*break*/, 1];
                        case 7: return [2 /*return*/, response];
                    }
                });
            }); })
                .catch(function (e) {
                EmailDialog.close();
            });
            return [2 /*return*/];
        });
    });
}
function sendEmailInfo(data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.post('/info/email', data)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function updatePhone(e) {
    return __awaiter(this, void 0, void 0, function () {
        var storage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    storage = UpdatePhoneDialog.getItemLocalStorage();
                    if (!storage) return [3 /*break*/, 2];
                    return [4 /*yield*/, updatePhone_onClick(e, true)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    console.log('isDintStorage');
                    return [4 /*yield*/, updatePhone_onClick(e, false)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
function updatePhone_onClick(e, isStorageExist) {
    return __awaiter(this, void 0, void 0, function () {
        var _phone, _code;
        var _this = this;
        return __generator(this, function (_a) {
            e.preventDefault();
            if (isStorageExist) {
                UpdatePhoneDialog.setDisabledInputPhoneBtn(true);
                UpdatePhoneDialog.setDisabledInputPhone(true);
                UpdatePhoneDialog.changePlaceTimer(true);
                UpdatePhoneDialog.startTimer(timerDurationDefault, false);
            }
            else {
                UpdatePhoneDialog.changePlaceTimer(false);
            }
            UpdatePhoneDialog.showInputPhone()
                .then(function (phone) { return __awaiter(_this, void 0, void 0, function () {
                var err_3;
                var _this = this;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            UpdatePhoneDialog.changePlaceTimer(false);
                            _phone = phone;
                            _b.label = 1;
                        case 1:
                            if (!true) return [3 /*break*/, 7];
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 6]);
                            if (!_phone)
                                throw new Error('Введите номер телефона');
                            if (!isValidPhone(_phone))
                                throw new Error('Введите корректный номер телефона');
                            return [4 /*yield*/, UpdatePhoneDialog.sendCheckCode({ PhoneNumber: _phone })];
                        case 3:
                            _b.sent();
                            UpdatePhoneDialog.startTimer(timerDurationDefault, true);
                            return [3 /*break*/, 7];
                        case 4:
                            err_3 = _b.sent();
                            UpdatePhoneDialog.setError(((_a = err_3.response) === null || _a === void 0 ? void 0 : _a.data) || err_3.message);
                            console.log(_phone);
                            return [4 /*yield*/, UpdatePhoneDialog.showInputPhone(_phone)
                                    .then(function (phone) {
                                    _phone = phone;
                                })];
                        case 5:
                            _b.sent();
                            return [3 /*break*/, 6];
                        case 6: return [3 /*break*/, 1];
                        case 7:
                            UpdatePhoneDialog.showInputCode()
                                .then(function (code) { return __awaiter(_this, void 0, void 0, function () {
                                var res, err_4;
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            _code = code;
                                            _b.label = 1;
                                        case 1:
                                            if (!true) return [3 /*break*/, 7];
                                            _b.label = 2;
                                        case 2:
                                            _b.trys.push([2, 4, , 6]);
                                            if (!_code)
                                                throw new Error('Введите проверочный код');
                                            res = getOnlyDigit(_code);
                                            if (res.length != 4)
                                                throw new Error('Проверочный код содержит 4 цифры');
                                            return [4 /*yield*/, updatePhoneInfo({ CheckCode: res })];
                                        case 3:
                                            _b.sent();
                                            return [3 /*break*/, 7];
                                        case 4:
                                            err_4 = _b.sent();
                                            UpdatePhoneDialog.setErrorCheckCode(((_a = err_4.response) === null || _a === void 0 ? void 0 : _a.data) || err_4.message);
                                            return [4 /*yield*/, UpdatePhoneDialog.showInputCode()
                                                    .then(function (code) {
                                                    _code = code;
                                                })];
                                        case 5:
                                            _b.sent();
                                            return [3 /*break*/, 6];
                                        case 6: return [3 /*break*/, 1];
                                        case 7:
                                            UpdatePhoneDialog.close();
                                            location.reload();
                                            return [2 /*return*/];
                                    }
                                });
                            }); })
                                .catch(function () {
                                UpdatePhoneDialog.close();
                            });
                            return [2 /*return*/];
                    }
                });
            }); })
                .catch(function () {
                UpdatePhoneDialog.close();
            });
            return [2 /*return*/];
        });
    });
}
function updatePhoneInfo(data) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.post('api/user/update', data)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function deletePhoneInfo() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.delete('api/user/access-code')];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function deletePhone_onClick(e) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            e.preventDefault();
            DeleteConfirmDialog.show()
                .then(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, deletePhoneInfo()];
                        case 1:
                            _a.sent();
                            DeleteConfirmDialog.close();
                            location.reload();
                            return [2 /*return*/];
                    }
                });
            }); })
                .catch(function (e) {
                DeleteConfirmDialog.close();
            });
            return [2 /*return*/];
        });
    });
}
function handleRequestException(ex) {
    if (ex.response) {
        console.log(ex.response);
        return ex.response.data;
    }
    else if (ex.request) {
        console.log('ex.request');
        console.log(ex.request);
    }
    else if (ex.message) {
        console.log('ex.message');
        console.log(ex.message);
    }
}
var PHONE_REGEXP = /((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}/;
var EMAIL_REGEXP = /^([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)/;
function isValidPhone(phone) {
    return PHONE_REGEXP.test(phone);
}
function isValidEmail(email) {
    return EMAIL_REGEXP.test(email);
}
function getOnlyDigit(str) {
    return str.replace(/\D/g, "");
}
